import React from 'react';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    width: 300,
    marginTop: '10px',
  },
});

const Loading = () => {
  const classes = useStyles();
  return (
    <Container maxWidth="sm" className={classes.root}>
      <CircularProgress />
    </Container>
  );
};

export default Loading;
